<template>
<div class="checkbox_container">
  <label for="cbx" class="customi_label">
    <input type="checkbox" class="invisible customi_input" v-model="checked">
    <div class="customi_div checkbox" @click="toggle">
      <svg class="customi_svg" viewBox="0 0 20 20">
        <path class="svg_bg" d="M3,1 L17,1 L17,1 C18.1045695,1 19,1.8954305 19,3 L19,17 L19,17 C19,18.1045695 18.1045695,19 17,19 L3,19 L3,19 C1.8954305,19 1,18.1045695 1,17 L1,3 L1,3 C1,1.8954305 1.8954305,1 3,1 Z"></path>
        <polyline class="svg_top checkbox_check" points="4 11 8 15 16 6"></polyline>
      </svg>
    </div>
    <span>{{label}}</span>
  </label>
</div>
</template>

<script>
export default {
  name: 'checkBox',
  props: {
    label: { type: String },
    emitOnChange: {
      type: Boolean,
      default: false
    },
    initialChecked: {
      type: Boolean,
      default: false
    },
    disabled: {type: Boolean}
  },
  methods: {
    reset () {
      this.checked = false;
    },
    toggle: function () {
      if (this.disabled) { return; }
      this.checked = !this.checked;
      if (this.emitOnChange) {
        if (this.checked) {
          this.$emit('checkbox-checked');
        } else {
          this.$emit('checkbox-unchecked');
        }
      }
    },
    externalToggle: function (checked) {
      this.checked = checked;
    },
    isChecked () {
      return this.checked;
    }
  },
  data () {
    return {
      checked: true && this.initialChecked
    };
  },
  mounted () {
    this.checked = this.initialChecked || false;
  },
  watch: {
    initialChecked () {
      this.checked = this.initialChecked;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Modules/Misc/checkBox.vue